import { useDecision } from '@optimizely/react-sdk';

import { FeatureFlags, ManageInstanceDefaultsVariables } from '@frontend/constants/featureFlags';

/**
 * Boolean variables of the `manage_instance_defaults` flag, each gating one
 * instance-wide default an admin can set in Settings.
 */
export function useManageInstanceDefaults() {
  const [decision] = useDecision(FeatureFlags.MANAGE_INSTANCE_DEFAULTS);
  const vars = decision?.variables;

  return {
    defaultCmpInstance: Boolean(vars?.[ManageInstanceDefaultsVariables.DEFAULT_CMP_INSTANCE]),
  };
}
